//@ts-check
import {Text} from '@/components-v2/atoms/Text/Text'
import {LabelValue} from '@/components-v2/molecules'
import {useProductCombo} from '@/context/ProductCombo/ProductComboContext'
import {ProductComboSteps} from '@/types/productComboTypes'
import {ComboReviewSection} from './ComboReviewSection'

export const ComboReviewSetup = () => {
  const {
    productCombo: {name, active, segmentConfiguration, allCustomers, businessGroup, comboLimit},
  } = useProductCombo()

  const includedSegments = segmentConfiguration?.includedSegments?.[0]?.segments ?? []
  const excludedSegments = segmentConfiguration?.excludedSegment?.segments ?? []
  let segmentsLabel = '-'
  let excluding = 'No'
  if (includedSegments.length > 0) {
    segmentsLabel = includedSegments.map(seg => seg.segmentName || seg.segmentId).join(', ')
  } else if (excludedSegments.length > 0) {
    segmentsLabel = excludedSegments.map(seg => seg.segmentName || seg.segmentId).join(', ')
    excluding = 'Yes'
  }

  return (
    <ComboReviewSection
      label="Setup"
      step={ProductComboSteps.SETUP}
      content={
        <div className="flex w-full flex-col gap-6 overflow-hidden">
          <div>
            <Text size="small" variant="bold">
              Combo Setup
            </Text>
            <div className="grid grid-cols-1 gap-x-4 md:grid-cols-3">
              <LabelValue keyName="Combo Name" val={name} />
              <LabelValue keyName="Combo Limit" val={comboLimit} />
            </div>
          </div>
          <div>
            <Text size="small" variant="bold">
              Availability
            </Text>
            <div className="mt-2 h-px bg-[var(--secondary-800)]" />
            <LabelValue keyName="Active" val={active ? 'Yes' : 'No'} />
          </div>
          <div>
            <Text size="small" variant="bold">
              Segments
            </Text>
            <div className="mt-2 h-px bg-[var(--secondary-800)]" />
            <div className="grid grid-cols-1 gap-x-4 md:grid-cols-3">
              <LabelValue keyName="All Customers" val={allCustomers ? 'Yes' : 'No'} />
              <LabelValue keyName="Segments" val={segmentsLabel} />
              <LabelValue keyName="Excluding" val={excluding} />
              <LabelValue
                keyName="Business Group"
                val={businessGroup ? (businessGroup === 'SNK' ? 'Snacks' : 'Beverages') : '-'}
              />
            </div>
          </div>
        </div>
      }
    />
  )
}
